var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31066 19.9705C3.31066 20.1694 3.38968 20.3601 3.53033 20.5008C3.67098 20.6414 3.86175 20.7205 4.06066 20.7205C4.25957 20.7205 4.45034 20.6414 4.59099 20.5008L20.5009 4.59089C20.6415 4.45023 20.7206 4.25947 20.7206 4.06056C20.7206 3.86164 20.6415 3.67088 20.5009 3.53023C20.3602 3.38957 20.1695 3.31056 19.9706 3.31056C19.7717 3.31056 19.5809 3.38957 19.4402 3.53023L3.53033 19.4401C3.38968 19.5808 3.31066 19.7715 3.31066 19.9705Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06055 3.31066C3.86164 3.31066 3.67087 3.38968 3.53022 3.53033C3.38956 3.67098 3.31055 3.86175 3.31055 4.06066C3.31055 4.25957 3.38956 4.45034 3.53022 4.59099L19.4401 20.5009C19.5808 20.6415 19.7715 20.7206 19.9704 20.7206C20.1694 20.7206 20.3601 20.6415 20.5008 20.5009C20.6414 20.3602 20.7204 20.1695 20.7204 19.9706C20.7205 19.7717 20.6414 19.5809 20.5008 19.4402L4.59088 3.53033C4.45022 3.38968 4.25946 3.31066 4.06055 3.31066Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.671a6b8058c74b2d5e24b6a07ed5363e.svg";
export { ForwardRef as ReactComponent };